import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyArTkQi-BlJt-BrkMjOdE9sp0gVnFjLLbo",
  authDomain: "punl-96882.firebaseapp.com",
  projectId: "punl-96882",
  storageBucket: "punl-96882.firebasestorage.app",
  messagingSenderId: "244215342343",
  appId: "1:244215342343:web:f2f548c88a3060c30391a2",
  measurementId: "G-PX8ENZJ9FR",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export function track(eventName, params = {}) {
  logEvent(analytics, eventName, params);
}
